import React, {useContext, useEffect, useState} from "react"
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import Tag from "@amzn/meridian/tag";
import Column from "@amzn/meridian/column"
import ControlGroup from "@amzn/meridian/control-group"
import Checkbox from "@amzn/meridian/checkbox"
import {LineHaulFilterContext} from "./context/LineHaulFilterContext";
import Select, { SelectOption } from "@amzn/meridian/select"
import Text from "@amzn/meridian/text"
import {FormattedMessage, injectIntl} from "react-intl";
import {ConfigContext} from "../global/context/ConfigContext";
import {getNodeCapabilityFromParent} from "../handler/ParentDataHandler";
import {parseCapabilitiesResponse} from "../util/Util";
import {CAPABILITY} from "../util/Constants";

const LineHaulFilter = ({ intl }) => {
    const [ filterState, setFilterState ] = useState(false)
    const { filter, dispatch } = useContext(LineHaulFilterContext)
    const isPackageSizeFilterVisible = filter.Split.includes('PackageSize')
    const isEADFilterVisible = filter.Split.includes('EAD')
    const isCycleFilterVisible = filter.Split.includes('Cycle')
    const isClusterFilterVisible = filter.Split.includes('Cluster')
    const isOtherAttributesVisible = filter.Split.includes('OtherAttributes')
    const toggleFilter = () => {
        setFilterState(!filterState)
    }

    const getCycleName = (cycleId) => {
        if(cycleId === "NONE") {
            return "Unplanned";
        }
        return cycleId;
    }

    const {configDispatch, configViewModel} = useContext(ConfigContext);

    useEffect(() => {
        getNodeCapabilityFromParent().then(capabilityResponse => {
            const capability = parseCapabilitiesResponse(capabilityResponse)
            configDispatch({type: 'GET_CAPABILITIES', capability});
            dispatch({type: 'LOAD_VIEW', data:{dispatcher: dispatch}});
        })
    }, []);

    const renderCycleCheckBox = () => {
        return CAPABILITY.AR_NEXT_GEN !== configViewModel.capability && (
            <Checkbox value='Cycle' disabled={!filter.Filters.hasOwnProperty("Cycle")}>
                <FormattedMessage id="linehaul_filter.cycle" defaultMessage="Cycle"/>
            </Checkbox>
        )
    }

    const renderClusterCheckBox = () => {
        return CAPABILITY.AR_NEXT_GEN !== configViewModel.capability && (
            <Checkbox value='Cluster' disabled={!filter.Filters.hasOwnProperty("Cluster")}>
                <FormattedMessage id="linehaul_filter.cluster" defaultMessage="Cluster"/>
            </Checkbox>
        )
    }

    return (
        <Column>
            <Row widths={["grid-1", "grid-11"]} alignmentVertical="top" spacingInset="large large none large">
                <Link href="" type="secondary" onClick={toggleFilter}>Options</Link>
                <div className="filter-tag">
                    {Object.entries(filter).map(entry => {
                        const key = entry[0]
                        const values = entry[1]
                        return (
                            (Array.isArray(values) && key !== 'Split')? values.map(value => {
                                return <Tag key = {value} type="neutral"
                                                onClose={() => dispatch({ type: 'REMOVE_FILTER', data: {key, value}})}>{value}</Tag>
                            })  : null
                        )
                    })}
                </div>
            </Row>
            {filterState ? <Row alignmentVertical="top" spacingInset="medium large" backgroundColor="secondary">
                <Column  heights="fill" alignmentHorizontal="center">
                    <ControlGroup
                        label="Split"
                        name="split"
                        onChange={(data) => dispatch({ type: 'SELECT_SPLIT', Split:data })}
                        value = {filter.Split}>
                        <Checkbox value='PackageSize' disabled={!filter.Filters.hasOwnProperty("PackageSize")}>
                            <FormattedMessage id="linehaul_filter.packagesize" defaultMessage="Package Size"/>
                        </Checkbox>
                        <Checkbox value='EAD' disabled={!filter.Filters.hasOwnProperty("EAD")}>
                            <FormattedMessage id="linehaul_filter.ead" defaultMessage="EAD"/>
                        </Checkbox>
                        {renderCycleCheckBox()}
                        {renderClusterCheckBox()}
                        <Checkbox value='OtherAttributes' disabled={!filter.Filters.hasOwnProperty("OtherAttributes")}>
                            <FormattedMessage id="linehaul_filter.otherattributes" defaultMessage="Other Attributes"/>
                        </Checkbox>
                    </ControlGroup>
                </Column>
                {isPackageSizeFilterVisible ? <Column  heights="fill" alignmentHorizontal="center" spacingInset="none medium none">
                    <ControlGroup
                        label={intl.formatMessage({id: 'linehaul_filter.packagesize'})}
                        name="packageSize"
                        onChange={(data) => dispatch({ type: 'SELECT_PACKAGE_SIZE', PackageSize:data })}
                        value = {filter.PackageSize}>
                        {filter.Filters.PackageSize.map(packageSize => (
                            <Checkbox key={packageSize} value={packageSize}>{packageSize}</Checkbox>
                        ))}
                    </ControlGroup>
                </Column> : null}
                {isEADFilterVisible ? <Column  heights="fill" alignmentHorizontal="left" spacingInset="none medium none">
                    <Text type="h100" alignment="left">
                        <FormattedMessage id="linehaul_filter.ead" defaultMessage="EAD"/>
                    </Text>
                    <Select
                        onChange={(data) => dispatch({ type: 'SELECT_EAD', EAD:data })}
                        value = {filter.EAD}
                        size="small"
                        placeholder="EAD"
                        width={150}>
                        {filter.Filters.EAD.map(ead => (
                            <SelectOption label={ead} value={ead}/>
                        ))}
                    </Select>
                </Column> : null}
                {isCycleFilterVisible ? <Column  heights="fill" alignmentHorizontal="center" spacingInset="none medium none">
                    <ControlGroup
                        label={intl.formatMessage({id: 'linehaul_filter.cycle'})}
                        name="cycles"
                        onChange={(data) => dispatch({ type: 'SELECT_CYCLE', Cycle:data })}
                        value = {filter.Cycle}>
                        {filter.Filters.Cycle.map(cycle => (
                            <Checkbox key={cycle.cycleId} value={cycle.cycleId}>{getCycleName(cycle.cycleId)}</Checkbox>
                        ))}
                    </ControlGroup>
                </Column> : null}
                {isClusterFilterVisible ? <Column  heights="fill" alignmentHorizontal="left" spacingInset="none medium none">
                    <Text type="h100" alignment="left">
                        <FormattedMessage id="linehaul_filter.cluster" defaultMessage="Cluster"/>
                    </Text>
                    <Select
                        onChange={(data) => dispatch({ type: 'SELECT_CLUSTER', Cluster:data })}
                        value = {filter.Cluster}
                        size="small"
                        placeholder="Cluster"
                        width={150}>
                        {filter.Filters.Cluster.sort().map(cluster => (
                            <SelectOption key={cluster} label={cluster} value={cluster}/>
                        ))}
                    </Select>
                </Column> : null}
                {isOtherAttributesVisible ? <Column  heights="fill" alignmentHorizontal="center" spacingInset="none medium none">
                    <ControlGroup
                        label={intl.formatMessage({id: 'linehaul_filter.otherattributes'})}
                        name="other_attributes"
                        onChange={(data) => dispatch({ type: 'SELECT_OTHER_ATTRIBUTES', OtherAttributes:data })}
                        value = {filter.OtherAttributes}>
                        {filter.Filters.OtherAttributes.map(otherAttributes => (
                            <Checkbox key={otherAttributes} value={otherAttributes}>{otherAttributes}</Checkbox>
                        ))}
                    </ControlGroup>
                </Column> : null}
            </Row> : null}
        </Column>
    );
}

export default injectIntl(LineHaulFilter)


// WEBPACK FOOTER //
// ./src/components/linehaul/LineHaulFilter.js